// Centralized handling of expired/invalid auth sessions (HTTP 401).
//
// Authenticated requests are scattered across many components that don't all
// have access to the logout handler or the translation context. Instead of
// threading those through every component, App registers a single handler here
// and each request calls `handleUnauthorized(response)` after fetching.

import { translations } from '../i18n/translations';

let sessionExpiredHandler = null;
// Guard so multiple simultaneous 401s (e.g. a mutation followed by a reload)
// only trigger one alert + logout.
let alreadyNotified = false;

// Called by App to wire the logout/reset-to-login behaviour.
export const registerSessionExpiredHandler = (fn) => {
  sessionExpiredHandler = fn;
};

// Re-arm notifications after a successful (re)login.
export const resetSessionExpiredNotice = () => {
  alreadyNotified = false;
};

// If `response` is a 401, notify the user (once) and log them out.
// Returns true when the response was an expired session so callers can bail out
// of their success path, e.g. `if (handleUnauthorized(response)) return;`.
export const handleUnauthorized = (response) => {
  if (!response || response.status !== 401) {
    return false;
  }

  if (!alreadyNotified) {
    alreadyNotified = true;
    const language = localStorage.getItem('language') || 'fi';
    const message =
      translations[language]?.sessionExpired || translations.en.sessionExpired;
    // eslint-disable-next-line no-alert
    alert(message);
    if (sessionExpiredHandler) {
      sessionExpiredHandler();
    }
  }

  return true;
};
